module.exports = __webpack_public_path__ + "media/images/barbecue-eaa5672c368cdf7c865e1a7831212d71.jpg";